export const isNil = (value: any): boolean => value === null || value === undefined;
export const isObject = (value: any): boolean => typeof value == 'object';
